import { Injectable } from '@angular/core';
import { DeviceSyncStatusService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DeviceActiveSyncsApiActions, DeviceActiveSyncsResolverActions } from './devices-active-syncs.actions';
import { safeMap } from '@era/stores';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class DeviceActiveSyncsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: DeviceSyncStatusService
  ) {}

  deviceActiveSyncCountRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceActiveSyncsResolverActions.deviceActiveSyncCountRequested),
      mergeMap(() =>
        safeMap(
          this.api.getCurrentActiveDeviceSyncs(),
          (count) => DeviceActiveSyncsApiActions.deviceActiveSyncCountLoaded({ currentActiveSyncs: count }),
          (error) => DeviceActiveSyncsApiActions.deviceActiveSyncCountLoadedError({ error })
        )
      )
    );
  });
}
